import { idToStrongId } from "@oysterhr/common"
import { CountryIsoCode } from "@oysterhr/schema"
import { stringifyUrl } from "query-string"
import { generatePath } from "react-router-dom"
import { companyBasePath } from "../../utils/baseRoutes"

// HIRE
const _hiresPath = ({
  companyId,
  path,
  query,
  hash,
}: {
  companyId: string
  path?: string
  query?: string
  hash?: string
}) => {
  return companyBasePath({
    companyId,
    path: generatePath("hires/*", { "*": path || "" }),
    query,
    hash,
  })
}

export const companyHiresPath = (companyId: string) => {
  return _hiresPath({ companyId })
}

export const companyAboutHiringPath = (companyId: string) => {
  return _hiresPath({ companyId, path: "about" })
}

// INTEGRATIONS
export const companyIntegrationHiresPath = (companyId: string) => {
  return _hiresPath({ companyId, hash: "integration_hires" })
}

// NEW HIRES
export const companyNewHirePath = (
  companyId: string,
  countryCode?: CountryIsoCode | string | null,
  hireId?: string,
) => {
  return stringifyUrl({
    url: _hiresPath({ companyId, path: "new" }),
    query: {
      countryCode,
      ...(hireId ? { hireId } : {}),
    },
  })
}

export const companySetupColleaguePath = ({
  companyId,
  employmentId,
  hash,
}: {
  companyId: string
  employmentId: string
  hash?: string
}) => {
  return _hiresPath({ companyId, path: `${idToStrongId(employmentId)}/setup`, hash })
}
